import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getRsvpUnitSubtitleForAttendee } from './getRsvpUnitSubtitleForAttendee';
import { getRsvpUnitSubtitleForOrganizer } from './getRsvpUnitSubtitleForOrganizer';
import { isItemSenderTheMeetingAttendee } from 'mini-meeting-invite/lib/utils/isItemSenderTheMeetingAttendee';

/**
 * Given a item and its meeting message details, this returns the subtitle for that item
 * @param item
 * @param originalMeetingMessage
 */
export const getRsvpUnitSubtitle = (
    item: CalendarEvent,
    originalMeetingMessage: MeetingMessage
): string => {
    let subtitle: string;
    if (isItemSenderTheMeetingAttendee(originalMeetingMessage)) {
        subtitle = getRsvpUnitSubtitleForAttendee(item, originalMeetingMessage);
    }

    return subtitle || getRsvpUnitSubtitleForOrganizer(item, originalMeetingMessage);
};
